module.exports = __webpack_public_path__ + "static/media/trophy.62b42f48.png";